import { LOCATION_INITIALIZED } from "@angular/common";
import { Injector } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, from, switchMap, tap } from "rxjs";

export function appInitializerFactory(translate: TranslateService, injector: Injector): () => Observable<unknown> {
	return () => {
		const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
		const langToSet = "de";
		return from(locationInitialized).pipe(
			switchMap(() => translate.use(langToSet)),
			tap(() => console.log("Translations initialized.")),
		);
	};
}
